<form #form="ngForm">
    <div *ngIf="(samlService.get() | async) as saml; else loading">
        <!--Type Authentification-->
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.authentification.saml.saml'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <!--Mode métadonnées-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="metadonneesSelect"
                            [selectOptions]="metadonneesSelectOptions"
                            libelle="admin.parametres.authentification.saml.type"
                            name="metadonnees"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                    <!--URl des métadonnées-->
                    <custom-input
                            ngDefaultControl
                            customType="input"
                            [(ngModel)]="saml.config.idpUrl"
                            libelle="admin.parametres.authentification.saml.url"
                            name="url"
                            [required]="true"
                            *ngIf="metadonneesSelect === MetadonneesType.URL"
                    ></custom-input>

                    <!--Fichier des métadonnées-->
                    <ng-container *ngIf="metadonneesSelect === MetadonneesType.FICHIER" class="">
                        <label class="col-md-2">
                            <span translate>admin.parametres.authentification.saml.fichier</span>
                        </label>
                        <div class="col-md-4">
                            <input type="file"
                                   (change)="onFileSelected($event)"
                                   accept=".xml"
                                   name="idpFile"
								   #idpFileInput
                                   style="display:none">
                            <button mat-button color="primary" (click)="idpFileInput.click()" class="button-input mt-2">
                                <span translate>{{ saml.config.hasIdpFile ? 'admin.parametres.authentification.saml.modifierFichier' : 'admin.parametres.authentification.saml.selectionnerFichier' }}</span>
                                <mat-icon color="primary">open_in_new</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <!--Mode-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="saml.config.mode"
                            [selectOptions]="modeSelectOptions"
                            libelle="admin.parametres.authentification.saml.mode"
                            name="mode"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                    <!--Contexte d'authentification-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="saml.config.authContext"
                            [selectOptions]="contextSelectOption"
                            libelle="admin.parametres.authentification.saml.contexte"
                            name="context"
                            optionDisplay="libelle"
                            optionValue="type"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Default claim-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="claimSelect"
                            (ngModelChange)="onClaimSelectChange($event, saml.config)"
                            [selectOptions]="claimSelectOptions"
                            libelle="admin.parametres.authentification.saml.defaultClaim"
                            name="defaultClaim"
                            optionDisplay="libelle"
                            optionValue="type"
                            [lCol]="2" [rCol]="2"
                            [hasForcedError]="claimSelect == ClaimType.PERSONNALISE && saml.config.defaultClaim == ''"
                    ></custom-input>
                    <ng-container *ngIf="claimSelect === ClaimType.PERSONNALISE">
                        <custom-input
                                ngDefaultControl
                                customType="input"
                                [(ngModel)]="saml.config.defaultClaim"
                                name="defaultClaimTexte"
                                [rCol]="2"
                                [required]="true"
                        ></custom-input>
                    </ng-container>
                    <!--Remplissage-->
                    <div *ngIf="claimSelect === ClaimType.NAMEID" class="col-md-2"></div>

                    <!--Chiffrement-->
                    <custom-input
                            ngDefaultControl
                            id="chiffrement"
                            name="chiffrement"
                            customType="checkbox"
                            [ngModel]="saml.config.encryptNameId"
                            [(customModel)]="saml.config.encryptNameId"
                            lCol="2" rCol="4"
                            libelle="admin.parametres.authentification.saml.chiffrement"
                            postLibelle="admin.parametres.authentification.saml.chiffrementSuffix"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Certificat-->
                    <label class="col-md-2" [ngClass]="{ 'has-error': isCertificatError(saml.config)}">
                        <span translate>admin.parametres.authentification.saml.certificat</span>
                    </label>
                    <div class="col-md-4">
                        <button mat-button color="primary" (click)="onCertificatClick()" class="button-input">
                            <span translate>admin.parametres.authentification.saml.gestionCertificat</span>
                            <mat-icon color="primary">open_in_new</mat-icon>
                        </button>
                    </div>
                    <!--Clef privée-->
                    <label class="col-md-2" [ngClass]="{ 'has-error': isClefPriveeError(saml.config)}">
                        <span translate>admin.parametres.authentification.saml.clefPrivee</span>
                    </label>
                    <div class="col-md-4">
                        <button mat-button color="primary" (click)="onClefPriveeClick()" class="button-input">
                            <span translate>admin.parametres.authentification.saml.gestionClef</span>
                            <mat-icon color="primary">open_in_new</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="samlService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>